/** Lista única de inbox IDs positivos, ordenada. */
export function normalizeInboxIdList(raw) {
  if (!Array.isArray(raw)) return [];
  const ids = [
    ...new Set(
      raw
        .map(v => parseInt(String(v), 10))
        .filter(n => Number.isFinite(n) && n > 0)
    ),
  ];
  ids.sort((a, b) => a - b);
  return ids;
}
